<template>
    <Layout>
        <section class="section">
            <div class="container">
                <h2>Confirmed Companies</h2>
                <p>
                    The list of attending companies will be made available soon.
                </p>
                <!-- <table id="companies-table">
				<thead>
					<tr>
						<th>
							Company
						</th>
						<th>
							Country
						</th>
						<th>
							RIC
						</th>
						<th>
							Bloomberg
						</th>
						<th>
							Sector
						</th>
						<th>
							Presentation
						</th>
						<th>
							Research
						</th>
					</tr>
				</thead>
				<tbody></tbody>
			</table> -->
            </div>

            <!-- <section class="section section-sm">
			<div class="container">
				<div class="text-center">
					<a class="download-companies-list btn" href="downloads/presenters-list.xlsx">Download Company List</a>
				</div>
			</div>
		</section> -->
        </section>
        <!-- <section class="section section_style">
      <h2>Invited Companies</h2>

      <table id="myTable" class="display">
        <thead>
          <tr v-if="companies">
            <th>Company</th>
            <th>Country</th>
            <th>Sector</th>
            <th>Presentations</th>
            <th>Research Report</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(company,index) in companies" v-bind:key="index">
            <td>{{ company.name }}</td>
            <td>{{ company.country.name}}</td>
            <td>{{ company.sector.name}}</td>

            <td class="presntation-font">
              <span
                class="_put-cursor"
                v-if="company.uploads.length > 0 && company.uploads[0].presentation"
                v-on:click="downloadFile(company.id , 'presentation' )"
              >Download Presentation</span>
            </td>

            <td class="presntation-font">
              <span
                class="_put-cursor"
                v-if="company.uploads.length > 0 &&company.uploads[0].profile"
                v-on:click="downloadFile(company.id , 'profile' )"
              >Download Profile</span>
            </td>
          </tr>
        </tbody>
      </table>

      <section class="section section-sm">
        <div class="container">
          <div class="text-center">
            <button
              @click="downloadCompaniesList"
              class="download-companies-list btn"
            >Download Company List</button>
          </div>
        </div>
      </section>
    </section> -->
    </Layout>
</template>

<script>
import Layout from "@/components/layouts/Layout.vue";
import Api from "@/Api";
import $ from "jquery";
import axios from "axios";
import JSZip from "jszip";
window.JSZip = JSZip; // required to make Buttons extension work for Excel button

import "datatables.net";
import "datatables.net-dt/css/jquery.dataTables.css";
import "datatables.net-buttons/js/dataTables.buttons";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons-dt/css/buttons.dataTables.min.css";
import "datatables.net-se";
import "datatables.net-buttons-se";

export default {
    name: "Companies",
    components: { Layout },

    data() {
        return {
            companies: []
        };
    },

    methods: {
        getPageData() {
            Api()
                .get("general/registerd-companies")
                .then(res => {
                    this.companies = res.data.companies;
                })
                .catch(error => console.log("error", error));
        },
        automaticDownloadAfterLogin() {
            let logged = this.$store.getters.isLoggedIn;
            let downloadUri = localStorage.getItem("beforeLoginChoice");
            if (logged && downloadUri) {
                let client = JSON.parse(localStorage.getItem("client"));
                if (downloadUri.toString() === "all") {
                    $("#myTable_wrapper .dt-buttons .buttons-excel").click();
                } else {
                    if (client.client.client_type.type === 1) {
                        window.location =
                            process.env.VUE_APP_API_URL + downloadUri;
                    }
                }
            }
            localStorage.removeItem("beforeLoginChoice");
        },
        downloadCompaniesList() {
            let logged = this.$store.getters.isLoggedIn;
            if (!logged) {
                localStorage.setItem("redirect", "/companies");
                localStorage.setItem("beforeLoginChoice", "all");
                this.$router.push({
                    name: "login"
                });
            } else {
                $("#myTable_wrapper .dt-buttons .buttons-excel").click();
            }
        },
        downloadFile: function(companyId, type) {
            let conferenceId = process.env.VUE_APP_CONFERENCE_ID;
            let logged = this.$store.getters.isLoggedIn;
            if (!logged) {
                let downloadUrl = `/files/general/download-file?company_id=${companyId}&file_type=${type}&conference_id=${conferenceId}`;
                localStorage.setItem("redirect", "/companies");
                localStorage.setItem("beforeLoginChoice", downloadUrl);
                this.$router.push({
                    name: "login"
                });
            } else {
                let client = JSON.parse(localStorage.getItem("client"));
                if (client.client.client_type.type === 1) {
                    window.location =
                        process.env.VUE_APP_API_URL +
                        `/files/general/download-file?company_id=${companyId}&file_type=${type}&conference_id=${conferenceId}`;
                } else {
                    return alert("Sorry you don't have permission");
                }
            }
        }
    },
    beforeMount(){
        if( window.location.href.includes("auth") )
        {
            let client = JSON.parse(localStorage.getItem("client"));
            if( !client || !(client.client.client_type.type === 1) )
            {
                window.location = '/';
            }
        }
    }, 
    mounted() {
        this.getPageData();
        this.automaticDownloadAfterLogin();
    },
    updated() {
        $("#myTable").DataTable({
            dom: "Bfrtip",
            buttons: [
                {
                    extend: "excelHtml5",
                    exportOptions: {
                        columns: [0, 1, 2]
                    }
                }
            ]
        });
        $("#myTable_wrapper .dt-buttons .buttons-excel").hide();
    }
};
</script>

<style>
.section_style {
    padding: 30px 64px;
}

.presntation-font {
    color: #004631;
    font-weight: bold;
}

._put-cursor {
    cursor: pointer;
}

/* DATA TABLE STYLES */
.dataTables_wrapper .dataTables_paginate .paginate_button.current,
.dataTables_wrapper .dataTables_paginate .paginate_button.current:hover {
    background: none;
}

.dataTables_wrapper .dataTables_paginate .paginate_button:hover {
    background: none;
    color: #a2ad1c !important;
    border: 1px solid #a2ad1c;
}
</style>
